import React, { useEffect, useState } from 'react';
import { getStyles } from './StoreProfile.style';
import { Image } from 'react-bootstrap';
import ProfileImage from '../../assets/images/avtar.png';
import { My_Store } from '../../Api';
import { Link } from 'react-router-dom';
import { STORAGE_CONSTANTS } from '../../shared/Constants/Constants';
import { base_url } from '../../Api/ApiConst';
import { useTranslation } from 'react-i18next';

const StoreProfile: React.FC = () => {
  const { t, i18n } = useTranslation();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const styles = getStyles(isMobile);
  const [storeid, setStoreid] = useState<string | null>("");
  const [storetoken, setStoretoken] = useState<string | null>("");
  const [storeData, setStoreData] = useState<any>(null);

  useEffect(() => {
    setStoretoken(localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN))
    window.scrollTo(0, 0);
  }, []);

  useEffect(() =>{
    if (storetoken) {
      const handleAPI = async () => {
        try {
          const response = await My_Store(storetoken);
          if (response && response.status === 200) {
            setStoreid(response.data.my_stores[0].id)
            setStoreData(response.data.my_stores[0]);

          } else {
            console.log("Error fetching My Store details");
          }
        } catch (error) {
          console.log("Error fetching My Store details", error);
        }
      };
      handleAPI();
    }
  },[storetoken])
  if (!storeData) {
    return null; // or loading indicator
  }

  const { store_name, contact_number, email,logo } = storeData;

  return (
    <>
    <h3 className="tab-title">{t("userProfile.storeProfile")}</h3>
    <div style={styles.basicInfo} className="d-flex align-items-center profile-row">
      <div style={styles.profileImageWrap}>
        <Image src={logo ? `${base_url}${logo}` : ProfileImage} style={styles.profileImage} />
      </div>
      <div style={styles.info}>
        <h3 style={styles.name}>{store_name}</h3>
        <h3 style={styles.phone}>{contact_number}</h3>
        <h3 style={styles.email}>{email}</h3>
      </div>
    </div>
  
    <div className='d-flex justify-content-end mt-3'>
      <Link to="/set-store" className='btnBlue'>{t("userProfile.updateStore")}</Link>
    </div>
  </>
  )
};

export default StoreProfile;
